module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "form__options"
  }, [_c('input', {
    staticClass: "form__checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "id": _vm.uniqueId,
      "data-acc": _vm.acc.toLowerCase()
    },
    domProps: {
      "checked": _vm.isChecked,
      "value": _vm.isChecked
    },
    on: {
      "change": _vm.onChange,
      "click": _vm.onClick
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__toggle form__label tooltip",
    attrs: {
      "data-acc": "toggle",
      "for": _vm.uniqueId
    }
  }, [_vm._v("\n    " + _vm._s(_vm.L.localize(_vm.label))), (_vm.hasTooltip) ? _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v(_vm._s(_vm.L.localize(_vm.tooltip)))]) : _vm._e()]), _vm._v(" "), (_vm.notice) ? _c('label', {
    staticClass: "form__options__notice",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(_vm._s(_vm.L.localize(_vm.notice)))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a438056!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/forms/CheckBox.vue
// module id = 712
// module chunks = 1